import React, { FC } from 'react'
import { Box } from '@moonpig/launchpad-components'
import { DepartmentsEnum } from '@moonpig/web-shared-types-graphql/graphqlTypes'
import { useProductStore } from '../../contexts/product'
import { ProductTabs } from '../../components/ProductTabs'
import { ModuleContext, ModuleProductTabs } from '../types'

type Props = {
  module: ModuleProductTabs
  context: ModuleContext
}

export const ProductTabsModule: FC<Props> = ({
  module: _module,
  context: _context,
}) => {
  const [{ product }] = useProductStore()

  const description = product.description ?? ''
  const department = product.category.department as DepartmentsEnum

  return (
    <Box mt={8} data-testid="module-product-tabs">
      <ProductTabs
        productId={product.id}
        description={description}
        department={department}
        rating={product.rating ?? null}
      />
    </Box>
  )
}
